var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 8.90983C18.0037 8.73248 17.9523 8.55831 17.8526 8.41155C17.753 8.26479 17.61 8.15272 17.4437 8.09094C17.2774 8.02915 17.096 8.02071 16.9247 8.0668C16.7534 8.11288 16.6008 8.21119 16.4879 8.34807L12.0138 13.5707L7.54126 8.34807C7.47167 8.25338 7.38332 8.17409 7.28167 8.11515C7.18001 8.0562 7.06725 8.01889 6.95051 8.00553C6.83376 7.99218 6.71554 8.00307 6.6032 8.03753C6.49086 8.07198 6.38681 8.12927 6.29764 8.20579C6.20846 8.28231 6.13612 8.37642 6.085 8.48222C6.03388 8.58802 6.00517 8.70324 6.00064 8.82066C5.99611 8.93808 6.0158 9.05517 6.05862 9.1646C6.10144 9.27402 6.16638 9.37343 6.2494 9.4566L11.3654 15.436C11.4455 15.5299 11.545 15.6053 11.657 15.657C11.7691 15.7087 11.8911 15.7355 12.0146 15.7355C12.138 15.7355 12.26 15.7087 12.3721 15.657C12.4842 15.6053 12.5838 15.5299 12.6639 15.436L17.7848 9.4566C17.919 9.30555 17.9952 9.11181 18 8.90983L17.9998 8.90983Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f76dda13ef033feac1951f24d8dfa129.svg";
export { ForwardRef as ReactComponent };